// const ip = "http://192.168.1.110/";
const ip = "https://vitaus.com.tr/";
const ip2 = "http://192.168.1.117/"

export default ip;
export const localIp = ip2;